import { Alert, Box, Button, Checkbox, FormControlLabel, Link as MuiLink, TextField, Typography } from "@mui/material"
import { Formik, getIn } from "formik"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Link as RouterLink } from "react-router-dom"
import { useAuth } from "../../auth"
import yup from "../../utils/validations"

export function Login() {
  const { performLogin, loginError } = useAuth()
  const { t } = useTranslation()
  const schema = useMemo(() => {
    return yup.object().shape({
      email: yup.string().email().required().label(t("login.schema_email_label")),
      password: yup.string().required().label(t("login.schema_password_label")),
    })
  }, [t])
  const initialValues = {
    email: "",
    password: "",
  }
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" flexDirection="column" padding={2}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        p={3}
        borderRadius={1}
        boxShadow={3}
        minWidth={395}
        maxWidth={464}
      >
        <Box display="flex" flexDirection="column" alignItems="center" gap={1} marginBottom={4} width="100%">
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              textAlign: "center",
              color: "rgba(0, 0, 0, 0.87)",
            }}
          >
            {t("login.title")}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "15px",
              lineHeight: "133.4%",
              color: "#757575",
            }}
          >
            {t("login.subtitle")}
          </Typography>
        </Box>
        <Formik
          validationSchema={schema}
          initialValues={initialValues}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            performLogin(values).finally(() => {
              setSubmitting(false)
            })
          }}
        >
          {({ handleSubmit, isSubmitting, errors, values, setFieldValue, isValid }) => (
            <form onSubmit={handleSubmit} style={{ width: "100%" }} noValidate>
              <Box display="flex" flexDirection="column" alignItems="center" width="100%" gap={1} marginBottom={1}>
                <TextField
                  label={t("login.email")}
                  type="email"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={values.email}
                  onChange={(e) => setFieldValue("email", e.target.value)}
                  helperText={getIn(errors, "email")}
                  error={getIn(errors, "email") ? true : false}
                  required
                />
                <TextField
                  label={t("login.password")}
                  type="password"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={values.password}
                  onChange={(e) => setFieldValue("password", e.target.value)}
                  required
                  helperText={getIn(errors, "password")}
                  error={getIn(errors, "password") ? true : false}
                />
              </Box>
              <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={loginError ? 3 : 4}>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Ricordami"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      color: "#757575",
                    },
                  }}
                />
                <MuiLink
                  component={RouterLink}
                  to="/password-dimenticata"
                  variant="body1"
                  sx={{ color: "black", textDecoration: "none" }}
                >
                  {t("login.cta_lost_password")}
                </MuiLink>
              </Box>
              {loginError && (
                <Alert severity="error" sx={{ marginBottom: 2, width: "100%" }}>
                  {t("login.error_login")}
                </Alert>
              )}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                loading={isSubmitting}
                disabled={!values.email || !values.password || !isValid || isSubmitting}
                fullWidth
              >
                {t("login.cta_login")}
              </Button>
            </form>
          )}
        </Formik>
      </Box>
      <Box maxWidth={464} marginTop={2} textAlign="center">
        <Typography
          variant="body2"
          sx={{
            fontSize: "13px",
            lineHeight: "133.4%",
            color: "#000",
            marginTop: 3,
            fontWeight: 500,
          }}
        >
          Home Movies Digital Archive – database gestionale e di consultazione: realizzato nell’ambito del PNRR e finanziato dall’Unione europea – Next Generation EU- “Transizione digitale Organismi Culturali e Creativi - TOCC”
        </Typography>
      </Box>
      <Box marginTop={2} textAlign="center">
        <img src="/logo_tocc.png" alt="Logo TOCC" style={{ height: 60 }} />
      </Box>
    </Box>
  )
}
